const RELOAD_GUARD_KEY = 'poketta-reloaded-for';
const MIN_CHECK_GAP_MS = 60 * 1000;

let lastCheck = 0;

// Reloads once if the deployed build differs from the one running. Failures are ignored so
// being offline never breaks the game.
const checkVersion = async (builtWith) => {
  if (Date.now() - lastCheck < MIN_CHECK_GAP_MS) return;
  lastCheck = Date.now();

  try {
    const res = await fetch(`version.json?t=${Date.now()}`, { cache: 'no-store' });
    if (!res.ok) return;
    const { version } = await res.json();
    if (!version || version === builtWith) return;

    // If a reload didn't pick up this version (CDN lag), don't loop on it.
    if (sessionStorage.getItem(RELOAD_GUARD_KEY) === version) return;
    sessionStorage.setItem(RELOAD_GUARD_KEY, version);
    window.location.reload();
  } catch {
    // offline, blocked storage, or bad JSON: leave the running build alone
  }
};

// Checks on load and whenever the tab comes back to the foreground, which is when a phone
// browser has typically been holding an old copy for days.
export const startVersionCheck = (builtWith) => {
  if (!builtWith || builtWith === 'dev') return;

  checkVersion(builtWith);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') checkVersion(builtWith);
  });
};
